module.exports = __webpack_public_path__ + "img/p13.44b28668.svg";